import React from 'react';
import styled from 'styled-components';
import { getTabNameByEntitySearchType, tabList } from '../utils';
import { SearchableEntityTypes } from '../types';
import { FavoriteStarIcon } from '../../../../components/Icon';
import { Tab, TabList, Tabs } from '../../../../components/Tabs';
import { theme } from '../../../../styles/theme';
import Pill from '../../../../components/Pill';

interface IProps {
  activeTab: SearchableEntityTypes | null;
  onClick: (tab: SearchableEntityTypes | null) => void;
  isFavoriteOnly: boolean;
  toggleFavoriteOnly: (favoriteOnly: boolean) => void;
}

const Container = styled.div`
  position: relative;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.border};
`;
const StyledTabList = styled(TabList)`
  flex: 1;
  border-bottom: 0;
`;

const UniversalSearchTabs = ({
  activeTab,
  onClick,
  isFavoriteOnly,
  toggleFavoriteOnly,
}: IProps) => {
  const handleChangeTab = (tabIndex: number) => {
    onClick(tabList[tabIndex]);
  };

  return (
    <Container>
      <Wrapper>
        <Tabs onTabChange={handleChangeTab}>
          <StyledTabList>
            {tabList.map((tab, tabIndex) => (
              <Tab
                key={`tab-${tab || 'all'}`}
                tabIndex={tabIndex}
                defaultActive={tab === activeTab}
              >
                {getTabNameByEntitySearchType(tab)}
              </Tab>
            ))}
          </StyledTabList>
        </Tabs>

        <Pill
          isActive={isFavoriteOnly}
          onClick={() => toggleFavoriteOnly(!isFavoriteOnly)}
        >
          <FavoriteStarIcon isActive={isFavoriteOnly} />
          Favorites
        </Pill>
      </Wrapper>
    </Container>
  );
};

export default UniversalSearchTabs;
